import React, { useState } from 'react';
import { AccountEditAssetForm } from '../EditAssetForm/components/AccountEditAssetForm/AccountEditAssetForm';
import {
  AccountAssetDTO,
  AccountAssetSimulatedDTO,
} from '../../../../api/useEstatePlanningExplanationQuery';
import { EmptyState } from '../../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { BeneficiariesData } from '../../useBeneficiaries';
import { Account } from './components/Account/Account';

interface Props {
  data: BeneficiariesData<AccountAssetDTO>[] | BeneficiariesData<AccountAssetSimulatedDTO>[];
  isSimulation: boolean;
}

export const Accounts = ({ data, isSimulation }: Props) => {
  const [selectedAsset, setSelectedAsset] = useState<
    AccountAssetDTO | AccountAssetSimulatedDTO | null
  >(null);

  if (data.length === 0) {
    return (
      <Box py="24">
        <EmptyState />
      </Box>
    );
  }

  return (
    <>
      {data.map(account => {
        return (
          <Box key={account.key}>
            <Account
              account={account}
              isSimulation={isSimulation}
              setSelectedAsset={setSelectedAsset}
            />
          </Box>
        );
      })}

      {selectedAsset && (
        <AccountEditAssetForm
          isSimulation={isSimulation}
          asset={selectedAsset}
          onRequestClose={() => {
            setSelectedAsset(null);
          }}
        />
      )}
    </>
  );
};
